/* ARCHADIA — homepage motion layer, part 2. See an-motion-plus.css. */
(function () {
  'use strict';
  if (window.__anmPlus) return;
  window.__anmPlus = 1;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var d = document;
  var touch = !(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  function init() {
    /* ---- Outlined text band that slides sideways as you scroll ---- */
    var cobSec = d.querySelector('.cob-section');
    var heroTitle = d.querySelector('.hero__title');
    var band = null, track = null;
    if (cobSec && cobSec.parentNode) {
      var txt = heroTitle ? heroTitle.textContent.split(' ').join(' ').replace(/\s+/g, ' ').trim() : '';
      if (!txt) txt = 'Archadia';
      var s = '';
      for (var i = 0; i < 6; i++) s += txt + ' \u2022 ';
      band = d.createElement('div');
      band.className = 'anm-band';
      band.setAttribute('aria-hidden', 'true');
      track = d.createElement('div');
      track.className = 'anm-band__t';
      track.textContent = s;
      band.appendChild(track);
      cobSec.parentNode.insertBefore(band, cobSec);

      var ticking = false;
      var frame = function () {
        ticking = false;
        var r = band.getBoundingClientRect();
        var wh = window.innerHeight;
        if (r.bottom < 0 || r.top > wh) return;
        var q = (wh - r.top) / (wh + r.height);
        track.style.transform = 'translate3d(' + (-q * 30).toFixed(2) + '%,0,0)';
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(frame); }
      }, { passive: true });
      frame();
    }

    if (!touch) return;

    /* ---- Touch: items in the middle of the screen get the highlight state ---- */
    if ('IntersectionObserver' in window) {
      var fio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.target.classList.toggle('anm-focus', en.isIntersecting); });
      }, { rootMargin: '-34% 0px -34% 0px', threshold: 0 });
      $$('.col-tile, .mof-step, .card, .dotw-image-wrap').forEach(function (el) { fio.observe(el); });
    }

    /* ---- Touch: swipe rows scale the front card up and push the rest back ---- */
    $$('.carousel, .latest-drop__grid').forEach(function (c) {
      var kids = Array.prototype.slice.call(c.children);
      var t = false;
      function upd() {
        t = false;
        if (c.classList.contains('reveal-stagger') && !c.classList.contains('is-in')) return;
        if (c.scrollWidth <= c.clientWidth + 8) return;
        var cr = c.getBoundingClientRect();
        var pl = parseFloat(window.getComputedStyle(c).paddingLeft) || 0;
        kids.forEach(function (k) {
          var r = k.getBoundingClientRect();
          var v = Math.abs(r.left - (cr.left + pl)) / (r.width || 1);
          v = (v > 1.6 ? 1.6 : v) / 1.6;
          k.classList.add('anm-car');
          k.style.transform = 'scale(' + (1 - 0.1 * v).toFixed(3) + ')';
          k.style.opacity = (1 - 0.5 * v).toFixed(3);
        });
      }
      c.addEventListener('scroll', function () {
        if (!t) { t = true; requestAnimationFrame(upd); }
      }, { passive: true });
      if (!c.classList.contains('reveal-stagger') || c.classList.contains('is-in')) {
        upd();
      } else if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () {
          if (c.classList.contains('is-in')) { mo.disconnect(); setTimeout(upd, 1250); }
        });
        mo.observe(c, { attributes: true, attributeFilter: ['class'] });
      }
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
